/**
 * Application types.
 *
 * @class ApplicationTypes
 * @memberof Mojito.Applications.Sports
 */
export default class ApplicationTypes {}

/**
 * Types of conditions to show a sliding betslip.
 *
 * @typedef SHOW_BETSLIP_CONDITION
 * @property {string} ADD_FIRST_SELECTION - A first selection is added.
 * @property {string} ADD_FIRST_PREPLAY_SELECTION - A first selection of the pre-play event is added.
 * @property {string} ADD_FIRST_INPLAY_SELECTION - A first of the in-play event selection is added.
 * @property {string} CONTAINS_MAX_ACCUMULATOR - Betslip has a max accumulator (on all selections).
 * @property {string} CONTAINS_ONE_BET_BUILDER - Betslip has one bet builder (on all selections).
 * @property {string} ADD_MATCH_ACCA - A match acca added is added. Betslip may have other selections.
 * @memberof Mojito.Applications.Sports.ApplicationTypes
 */
ApplicationTypes.SHOW_BETSLIP_CONDITION = {
    ADD_FIRST_SELECTION: 'ADD_FIRST_SELECTION',
    ADD_FIRST_PREPLAY_SELECTION: 'ADD_FIRST_PREPLAY_SELECTION',
    ADD_FIRST_INPLAY_SELECTION: 'ADD_FIRST_INPLAY_SELECTION',
    CONTAINS_MAX_ACCUMULATOR: 'CONTAINS_MAX_ACCUMULATOR',
    CONTAINS_ONE_BET_BUILDER: 'CONTAINS_ONE_BET_BUILDER',
    ADD_MATCH_ACCA: 'ADD_MATCH_ACCA',
};

/**
 * The name of the application settings store. Will be used to register in global redux store.
 *
 * @constant
 * @type {string}
 * @memberof Mojito.Applications.Sports.ApplicationTypes
 */
ApplicationTypes.STORE_KEY = 'application/main';
